import WaitForRedirect from "@casino/legacy/client/shared/WaitForRedirect";
import useCognitoCallback from "./useCognitoCallback";

const CognitoCallback: FC = () => {
  const { logo } = useCognitoCallback();

  return <WaitForRedirect logo={logo} />;
};

export default CognitoCallback;
